module.exports = __webpack_public_path__ + "static/23-thumb-a90b8670ec6bfa1b25cc558bb14ad5e7.jpg";